// extracted by css-extract-rspack-plugin
module.exports =  {"root":"TeamsEmpty-m__root___cPS70"};